import React from "react";
import { useTranslation } from "react-i18next";

const Education = () => {
  const { i18n } = useTranslation();
  return <div>{i18n.t("Education")}</div>;
};

export default Education;
